<div class="ui-kit-container">
	<!-- Sidebar -->
	<aside class="sidebar">
		<app-ui-sidebar 
			[currentSection]="currentSection()"
			(sectionChange)="onSectionChange($event)" />
	</aside>

	<!-- Main Content -->
	<main class="main-content">
		<h1>UI Components Library</h1>

		@if (currentSection() === 'buttons') {
			<app-ui-buttons />
		}

		@if (currentSection() === 'inputs') {
			<app-ui-inputs />
		}

		@if (currentSection() === 'password') {
			<app-ui-password />
		}

		@if (currentSection() === 'tabs') {
			<app-ui-tabs />
		}

	@if (currentSection() === 'tag') {
		<app-ui-tag />
	}

	@if (currentSection() === 'icon-status') {
		<app-ui-icon-status />
	}

	@if (currentSection() === 'textarea') {
			<app-ui-textarea />
		}

		@if (currentSection() === 'select') {
			<app-ui-select
				[selectControl]="selectControl"
				[disabledSelectControl]="disabledSelectControl"
				[errorSelectControl]="errorSelectControl"
			/>
		}

		@if (currentSection() === 'multiselect') {
			<app-ui-multiselect
				[multiselectControl]="multiselectControl"
				[disabledMultiselectControl]="disabledMultiselectControl"
				[errorMultiselectControl]="errorMultiselectControl"
			/>
		}

		@if (currentSection() === 'search') {
			<app-ui-search
				[searchControl]="searchControl"
				[disabledSearchControl]="disabledSearchControl"
				[errorSearchControl]="errorSearchControl"
				[multiselectSearchControl]="multiselectSearchControl"
			/>
		}

		@if (currentSection() === 'chips') {
			<app-ui-chips
				[chipsControl]="chipsControl"
				[disabledChipsControl]="disabledChipsControl"
				[errorChipsControl]="errorChipsControl"
			/>
		}

		@if (currentSection() === 'datepicker') {
			<app-ui-datepicker
				[datepickerControl]="datepickerControl"
				[disabledDatepickerControl]="disabledDatepickerControl"
				[errorDatepickerControl]="errorDatepickerControl"
				[rangeDatepickerControl]="rangeDatepickerControl"
				[inlineDatepickerControl]="inlineDatepickerControl"
				[weekViewControl]="weekViewControl"
				[timeDatepickerControl]="timeDatepickerControl"
			/>
		}

	@if (currentSection() === 'form-controls') {
		<app-ui-form-controls />
	}

	@if (currentSection() === 'theme-styles') {
		<app-ui-theme-styles />
	}

	@if (currentSection() === 'text-sizes') {
		<app-ui-text-sizes />
	}

	@if (currentSection() === 'loading') {
		<h2>Loading Components</h2>
		<p class="section-description">Diferentes tipos de indicadores de carga para distintos contextos.</p>

		<!-- Loading GK (Full screen - contained) -->
		<section class="ui-section">
			<h3>1. Loading GK (Pantalla completa - Login)</h3>
			<p>Se usa para bloquear toda la pantalla durante el login. Aquí se muestra contenido en un contenedor.</p>
			<div class="loading-gk-demo">
				<app-loading-gk [show]="true" />
			</div>
			<div class="code-block">
				<h4>Uso:</h4>
				<pre><code>&lt;!-- In the template (usually in app.component.html) --&gt;
&lt;app-loading-gk&gt;&lt;/app-loading-gk&gt;

// In the service/component:
import &#123; LoadingGkService &#125; from '&#64;services/ui/loading.service';

constructor(private loadingGkService: LoadingGkService) &#123;&#125;

// Show loading
this.loadingGkService.showLoading();

// Hide loading
this.loadingGkService.hideLoading();</code></pre>
			</div>
		</section>

		<!-- Spinner (Localized) -->
		<section class="ui-section">
			<h3>2. Spinner (Localizado)</h3>
			<p>Se usa para indicar carga en una sección específica sin bloquear el resto de la página.</p>
			<app-spinner [loading]="true">
				<div class="spinner-demo-content">
					<h4>Contenido del formulario</h4>
					<p>Este contenido se difumina mientras carga.</p>
					<div class="demo-inputs">
						<input type="text" placeholder="Nombre" disabled />
						<input type="text" placeholder="Email" disabled />
						<button type="button" disabled>Guardar</button>
					</div>
				</div>
			</app-spinner>
			<div class="code-block">
				<h4>Uso:</h4>
				<pre><code>&lt;!-- Wrap the content you want to cover with the spinner --&gt;
&lt;app-spinner [loading]="isLoading"&gt;
  &lt;div class="my-content"&gt;
    &lt;!-- Your content here --&gt;
  &lt;/div&gt;
&lt;/app-spinner&gt;

// In the component:
import &#123; SpinnerComponent &#125; from '&#64;shared/components/spinner/spinner.component';

&#64;Component(&#123;
  imports: [SpinnerComponent],
  // ...
&#125;)
export class MyComponent &#123;
  isLoading = false;

  loadData() &#123;
    this.isLoading = true;
    this.myService.getData().subscribe(&#123;
      next: (data) =&gt; &#123; /* ... */ &#125;,
      complete: () =&gt; this.isLoading = false,
      error: () =&gt; this.isLoading = false
    &#125;);
  &#125;
&#125;</code></pre>
			</div>
		</section>

		<!-- Skeleton -->
		<section class="ui-section">
			<h3>3. Skeleton (Placeholders)</h3>
			<p>Se usa para mostrar la estructura del contenido mientras se carga. Ejemplo de tabla con skeleton integrado.</p>
			
			<div class="skeleton-table-wrapper">
				<!-- Header -->
				<div class="skeleton-caption">
					<p-skeleton width="180px" height="24px" />
					<div class="skeleton-caption-actions">
						<p-skeleton width="250px" height="40px" borderRadius="8px" />
						<p-skeleton width="40px" height="40px" borderRadius="8px" />
						<p-skeleton width="120px" height="40px" borderRadius="8px" />
					</div>
				</div>

				<!-- Table -->
				<table class="skeleton-table-real">
					<thead>
						<tr>
							<th style="width: 50px;"><p-skeleton shape="circle" size="20px" /></th>
							<th><p-skeleton width="100px" height="16px" /></th>
							<th><p-skeleton width="80px" height="16px" /></th>
							<th><p-skeleton width="60px" height="16px" /></th>
							<th><p-skeleton width="90px" height="16px" /></th>
							<th style="width: 80px;"></th>
						</tr>
					</thead>
					<tbody>
						@for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
							<tr>
								<td><p-skeleton shape="circle" size="20px" /></td>
								<td>
									<div class="skeleton-cell-user">
										<p-skeleton shape="circle" size="40px" />
										<div class="skeleton-cell-user-info">
											<p-skeleton width="120px" height="14px" />
											<p-skeleton width="160px" height="12px" />
										</div>
									</div>
								</td>
								<td><p-skeleton width="100px" height="14px" /></td>
								<td><p-skeleton width="70px" height="24px" borderRadius="12px" /></td>
								<td><p-skeleton width="90px" height="14px" /></td>
								<td>
									<div class="skeleton-cell-actions">
										<p-skeleton shape="circle" size="32px" />
									</div>
								</td>
							</tr>
						}
					</tbody>
				</table>

				<!-- Paginator -->
				<div class="skeleton-paginator">
					<p-skeleton width="120px" height="14px" />
					<div class="skeleton-paginator-controls">
						<p-skeleton width="80px" height="32px" borderRadius="6px" />
						<p-skeleton width="32px" height="32px" borderRadius="6px" />
						<p-skeleton width="32px" height="32px" borderRadius="6px" />
						<p-skeleton width="32px" height="32px" borderRadius="6px" />
						<p-skeleton width="32px" height="32px" borderRadius="6px" />
					</div>
				</div>
			</div>
			<div class="code-block">
				<h4>Uso:</h4>
				<pre><code>&lt;!-- Import PrimeNG module --&gt;
import &#123; SkeletonModule &#125; from 'primeng/skeleton';

&lt;!-- Basic skeleton --&gt;
&lt;p-skeleton width="100px" height="16px" /&gt;

&lt;!-- Circular skeleton (avatar) --&gt;
&lt;p-skeleton shape="circle" size="40px" /&gt;

&lt;!-- Skeleton with rounded borders (tags/chips) --&gt;
&lt;p-skeleton width="70px" height="24px" borderRadius="12px" /&gt;

&lt;!-- Conditional example --&gt;
&#64;if (isLoading) &#123;
  &lt;p-skeleton width="100%" height="40px" /&gt;
&#125; &#64;else &#123;
  &lt;input type="text" [value]="data.name" /&gt;
&#125;</code></pre>
			</div>
		</section>
	}

	@if (currentSection() === 'toast') {
		<app-ui-toast />
	}

	@if (currentSection() === 'others') {
		<app-ui-others />
	}

	@if (currentSection() === 'not-found') {
		<h2>Not Found (404) Page</h2>
		<app-not-found />
	}

	@if (currentSection() === 'payment-required') {
		<h2>Payment Required Page</h2>
		<app-payment-required />
	}
	</main>
</div>
